/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_RequiredInputs */

const vi_validation_required = /** @type {(inputs: Validation_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trường này là bắt buộc`)
};

/**

* @param {Validation_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_required = /** @type {((inputs?: Validation_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_required(inputs)
});